import { Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'ui-stat-card',
  standalone: true,
  imports: [MatCardModule],
  templateUrl: './ui-stat-card.component.html'
})
export class UiStatCardComponent {
  readonly label = input('');
  readonly value = input('');
  readonly delta = input('');
}
